/**
 * @license
 * Powered by MaxDesign. All Rights Reserved.
 * ⚠ FR : CONTENU PROTÉGÉ PAR LES DROITS D'AUTEURS (article L. 111-1 du code de la propriété intellectuelle). Cette ressource ne peut pas être utilisée, diffusée ou exploitée sans l'approbation de ses auteurs. Pour plus d'informations, veuillez contacter admin(at)maxdesign.expert
 * ⚠ EN : CONTENT PROTECTED WITH AUTHOR COPYRIGHTS (section L. 111-1 of the intellectual property code). This resource may not be used, distributed or exploited without the approval of its authors. For any information request, please contact admin(at)maxdesign.expert
 */

MaxDesign = window.MaxDesign || class {};
MaxDesign.fileUpload = { get: () => document.querySelector('file-upload-maxdesign') };
class FileUpload extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.reset = this.querySelector('.reset');
    this.loader = this.querySelector('label');
    this.placeholder = this.querySelector('img');
    this.bundle = this.closest('.md-bundle');
    document.addEventListener('dragover', e => e.preventDefault());
    this.addEventListener('drop', this.onFileDrop.bind(this));
    this.input.addEventListener('change', this.onFileChange.bind(this));
    this.reset.addEventListener('click', this.onFileReset.bind(this));
  }
  onFileChange(e) {
    const file = e.target.files[0];
    this.handleFile(file);
  }
  onFileDrop(e) {
    e.preventDefault();
    const files = e.dataTransfer.files;
    this.handleFile(files[0]);
    this.input.files = files;
  }
  onFileLoad(file) {
    this.image = new Image();
    this.image.onload = () => {
      this.placeholder.src = this.reader.result;
      this.setAttribute('file-upload-reset', 'true');
      this.bundle?.slideDownAnimation();
      this.loader.dataset.loader = '';
    };
    this.image.src = file.target.result;
  }
  onFileReset(e) {
    e && e.preventDefault();
    this.input.value = '';
    this.setAttribute('file-upload-reset', 'false');
    this.bundle?.slideDownAnimation();
  }
  handleFile(file) {
    if (file.size / 1024 / 1024 > 50) {
      this.input.setCustomValidity('Maximum 50 MB');
      this.input.reportValidity();
      this.reset.dispatchEvent(new Event('click'));
      return;
    } else this.input.setCustomValidity('');
    this.loader.dataset.loader = 'loading';
    this.reader = new FileReader();
    this.reader.addEventListener('load', this.onFileLoad.bind(this));
    this.reader.readAsDataURL(file);
  }
}
customElements.get('file-upload-maxdesign') || customElements.define('file-upload-maxdesign', FileUpload);
